import config from "./config";

export const getCredits = async () => {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');

        fetch(config.api + '/auth/credits', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(response.status);
            }
            return response.json();
        })
        .then(data => {
            resolve(data);
        })
        .catch(error => {
            reject(error);
        });
    });
}


// WEBPACK FOOTER //
// ./src/api.js